import { render } from "./TestimonialsCarousel.vue?vue&type=template&id=a7e751fc"
import script from "./TestimonialsCarousel.vue?vue&type=script&lang=js"
export * from "./TestimonialsCarousel.vue?vue&type=script&lang=js"

import "./TestimonialsCarousel.vue?vue&type=style&index=0&id=a7e751fc&lang=scss"

import exportComponent from "/opt/render/project/src/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__